/**
 * Joins CSS class names and skips empty values (CSS Module lookups may be `undefined`).
 *
 * @param classes - Class names.
 * @returns The joined class attribute value.
 */
export function cx(...classes: readonly (string | false | null | undefined)[]): string {
  const joined = classes.filter((value) => typeof value === "string" && value !== "").join(" ");

  return joined;
}
